import React from "react";
import { Link } from "gatsby";

// Components
import SecondaryLanding from "../../layouts/secondary-landing";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import SEO from "../../components/seo/seo";
import FaqAccordion from "../../components/faq/faq-accordion";
import ContactInfo from "../../components/contact-info/contact-info";

// Helpers
import getSortedFaqDataByCategory from "../../helpers/sorted-faq-data-by-category";

const FAQ = () => {
  const { schema } = getSortedFaqDataByCategory([
    "CS - Mortgages and Loans",
    "CS - Online Banking and Mobile App",
    "CS - About WaFd Bank",
    "CS - About Your Account",
    "CS - Services and Tools"
  ]);

  const SEOData = {
    title: "Frequently Asked Questions (FAQs)",
    description:
      "Have a question about WaFd bank such as what is WaFd Bank's routing number? We answer your top questions here!",
    ogImagePath: "/images/adsearch/thumb-faq-01-250.jpg",
    ogImageAlt: "Two coworkers looking at a laptop's screen.",
    schema
  };

  const breadcrumbData = [
    {
      id: 1,
      active: true,
      title: "FAQs"
    }
  ];

  const faqAccordionData = [
    {
      id: "cs-mortgages-loans-faqs",
      faqCategoryNames: ["CS - Mortgages and Loans"],
      title: "Mortgages and Other Loans",
      titleClass: "h3",
      showContactBar: false,
      sectionClass: "pb-0"
    },
    {
      id: "cs-online-banking-mobile-app-faqs",
      faqCategoryNames: ["CS - Online Banking and Mobile App"],
      title: "Online Banking and the WaFd Mobile App",
      titleClass: "h3",
      showContactBar: false,
      sectionClass: "pb-0"
    },
    {
      id: "cs-about-wafd-faqs",
      faqCategoryNames: ["CS - About WaFd Bank"],
      title: "About WaFd Bank",
      titleClass: "h3",
      showContactBar: false,
      sectionClass: "pb-0"
    },
    {
      id: "cs-about-your-account-faqs",
      faqCategoryNames: ["CS - About Your Account"],
      title: "About Your Account",
      titleClass: "h3",
      showContactBar: false,
      sectionClass: "pb-0"
    },
    {
      id: "cs-services-tools-faqs",
      faqCategoryNames: ["CS - Services and Tools"],
      title: "Services, Tools and More",
      titleClass: "h3",
      showContactBar: false,
      sectionClass: "pb-0"
    }
  ];

  return (
    <SecondaryLanding>
      <SEO {...SEOData} />
      <div id="alert-stripe-messages" className="bg-success text-white py-2 text-center">
        Have a question about online or mobile banking at WaFd Bank?{" "}
        <Link
          id="alert-stripe-online-banking-faq-link"
          className="text-white hybrid-link"
          to="/personal-banking/online-banking/faq"
        >
          Visit our Mobile Banking FAQs!
        </Link>
      </div>
      <Breadcrumb data={breadcrumbData} />
      <section className="container pb-0">
        <h1 className="mb-0">WaFd Bank Frequently Asked Questions</h1>
      </section>
      {faqAccordionData.map((faq, index) => {
        return (
          <div key={index}>
            <FaqAccordion {...faq} />
          </div>
        );
      })}
      <ContactInfo />
    </SecondaryLanding>
  );
};

export default FAQ;
